import { AppDispatch } from "app/store";
import { selectAccessToken } from "features/identity/identitySlice";
import {
  loadProfileAsync,
  selectFirstLoginPasswordChanged,
  selectProfile,
} from "features/profile/profileSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FirstLoginPasswordChangeDialog from "./FirstLoginPasswordChangeDialog";

interface FirstLoginGuardProps {
  children: React.ReactNode;
}

const FirstLoginGuard: React.FC<FirstLoginGuardProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const profile = useSelector(selectProfile);
  const accessToken = useSelector(selectAccessToken);
  const firstLoginPasswordChanged = useSelector(
    selectFirstLoginPasswordChanged
  );
  const [showPasswordChangeDialog, setShowPasswordChangeDialog] =
    useState(false);

  useEffect(() => {
    // Only check for authenticated users with a profile
    if (
      accessToken &&
      profile?.id &&
      profile?.roles &&
      firstLoginPasswordChanged === false
    ) {
      setShowPasswordChangeDialog(true);
    } else {
      setShowPasswordChangeDialog(false);
    }
  }, [accessToken, profile, firstLoginPasswordChanged]);

  const handlePasswordChanged = async () => {
    // Reload profile to get updated first_login_password_changed status
    await dispatch(loadProfileAsync());
    setShowPasswordChangeDialog(false);
  };

  return (
    <>
      {children}
      <FirstLoginPasswordChangeDialog
        open={showPasswordChangeDialog}
        onPasswordChanged={handlePasswordChanged}
      />
    </>
  );
};

export default FirstLoginGuard;
